import React, { Component } from 'react';
import KayakApp from './containers/KayakApp'
import './App.css';

class App extends Component {
  render() {
    return (
      <KayakApp />
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js